module.exports = __webpack_public_path__ + "static/img/subbanner3.1ea29d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banners/subbanner3.jpg
// module id = bdAB
// module chunks = 1